module.exports = __webpack_public_path__ + "img/A.95c3f146.png";